import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { PLATFORM_STARTUP_ERROR_HANDLERS } from '@platform-frontend/platform';
import { SetIsLoading } from '@platform-frontend/ui-tools';
import { catchAndRethrow, CloseWindow, HandleErrorsGlobalRecord } from '@platform-frontend/util';
import { Observable, of, switchMap, takeUntil } from 'rxjs';
import { handleErrorsUntilSignedOutOnError } from './handle-errors-until-signed-out-on-error';
import { SessionState } from './session';
import { InitStartup } from './startup.actions';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class StartupService {
  constructor(private actions$: Actions, private store: Store) {}

  getStartupObservable(
    getStartupActions: () => Observable<unknown> = () => of(null),
    startupErrorHandlers: (error: any) => HandleErrorsGlobalRecord = PLATFORM_STARTUP_ERROR_HANDLERS
  ): Observable<unknown> {
    return this.store.dispatch(new SetIsLoading(true)).pipe(
      switchMap(() =>
        this.store.dispatch(new InitStartup(this.store.selectSnapshot(SessionState.isSignedIn), this.store.selectSnapshot(SessionState.isDisabled)))
      ),
      switchMap(() => getStartupActions()),
      switchMap(() => this.store.dispatch(new SetIsLoading(false))),
      catchAndRethrow(() => this.store.dispatch(new SetIsLoading(false))),
      takeUntil(this.actions$.pipe(ofActionDispatched(CloseWindow))),
      handleErrorsUntilSignedOutOnError(this.actions$, startupErrorHandlers)
    );
  }
}
